import { Element, Title } from '@zmedia/bm-soccer-ui/components';
import { memo, useState } from 'react';
import { IRankingTeam } from '@zmedia/bm-soccer-ui/interface';
import { TableHeader, TableRow } from '..';
import styles from '../style.module.scss';
import { SelectGroup } from './SelectGroup';

interface IGroup {
    id: number;
    name: string;
    items: IRankingTeam[];
    children?: React.ReactNode;
    selectMode?: boolean;
}
function GroupRanking(props: any) {
    const { groups = [], children, selectMode = false } = props;

    const renderList = (items: IRankingTeam[] = []) => {
        return items.map((item: IRankingTeam, index: number) => {
            return (
                <TableRow
                    item={item}
                    key={index}
                    hasMatchRecent={hasMatchRecent}
                />
            );
        });
    };

    const matches = groups.reduce((obj: IRankingTeam[], item: IGroup) => {
        return [...obj, ...item.items];
    }, []);

    const hasMatchRecent =
        matches.filter((item: IRankingTeam) => {
            return item?.mr?.length > 0;
        }).length > 0;

    const renderGroup = (groups: IGroup[] = []) => {
        return groups.map((group: IGroup, index: number) => {
            return (
                <Element className={styles['table-ranking']} key={index}>
                    <Title className={styles['group-title']}>
                        {group.name}
                    </Title>
                    <TableHeader hasMatchRecent={hasMatchRecent} />
                    <Element className={styles['tbody']}>
                        {renderList(group.items)}
                    </Element>
                    {children}
                </Element>
            );
        });
    };

    if (!groups.length) {
        return null;
    }

    if (selectMode) {
        return (
            <>
                <GroupSelectRanking {...props} />
            </>
        );
    }
    return <>{renderGroup(groups)}</>;
}

function GroupSelectRanking(props: any) {
    const { children, groups = [] } = props;

    const [groupActive, selectGroup] = useState(groups[0]);

    const hasMatchRecent =
        groupActive.items.filter((item: IRankingTeam) => {
            return item?.mr?.length > 0;
        }).length > 0;

    const renderList = (items: IRankingTeam[] = []) => {
        return items.map((item: IRankingTeam, index: number) => {
            return (
                <TableRow
                    item={item}
                    key={index}
                    hasMatchRecent={hasMatchRecent}
                />
            );
        });
    };

    const renderGroup = () => {
        return (
            <>
                <SelectGroup
                    groups={groups}
                    groupName={groupActive.name}
                    groupId={groupActive.id}
                    selectGroup={selectGroup}
                />
                <Element className={styles['table-ranking']}>
                    <TableHeader hasMatchRecent={hasMatchRecent} />
                    <Element className={styles['tbody']}>
                        {renderList(groupActive.items)}
                    </Element>
                    {children}
                </Element>
            </>
        );
    };

    return <>{renderGroup()}</>;
}

export default memo(GroupRanking);
